import type { FunctionComponent } from 'react';
import React from 'react';
import type { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { getBreakpoints, useBreakpoint } from '@noths/polaris-client-ribbons-base';

export interface ResponsiveProps {
  children?: React.ReactNode;
  maxBreakpoint?: Breakpoint;
  minBreakpoint?: Breakpoint;
}

export const Responsive: FunctionComponent<ResponsiveProps> = ({
  children,
  maxBreakpoint,
  minBreakpoint,
}: ResponsiveProps) => {
  const breakpoint = useBreakpoint({ initializeWithLarge: true });
  const breakpoints = getBreakpoints({ minBreakpoint, maxBreakpoint });

  return <>{breakpoints.includes(breakpoint) && children}</>;
};
